import { jsx } from "panel";
import { FullWidthReportEl } from "common/widgets/fullwidth-report";
import { DownloadWrapperEl } from "common/components/download-wrapper";
import { UpsellModalEl } from "common/widgets/upsell-modal";
export function template() {
  var _a, _b, _c, _d;
  const ReportQueryBuilderEl = (_a = this.state.reportManager) == null ? void 0 : _a.queryBuilderEl;
  const ReportVisualizationEl = (_b = this.state.reportManager) == null ? void 0 : _b.visualizationEl;
  const ReportHeaderEl = (_c = this.state.reportManager) == null ? void 0 : _c.reportHeaderEl;
  const visualizationEl = ReportVisualizationEl && /* @__PURE__ */ jsx(ReportVisualizationEl, {
    attrs: { ...this.visualizationAttrs(), elref: `reportVisualization` },
    props: this.visualizationProps(),
    hook: { insert: this.helpers.vizInserted },
    on: this.visualizationEventHandlers
  });
  if (this.isDownloadMode()) {
    return ReportVisualizationEl && /* @__PURE__ */ jsx(DownloadWrapperEl, {
      attrs: { meta: this.getReportMeta(), mode: this.getDownloadMode(), elref: `downloadWrapper` }
    }, visualizationEl);
  }
  const upsell = (_d = this.state.reportManager) == null ? void 0 : _d.getReportUpsell(this.currentProject);
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-report-editor"
  }, /* @__PURE__ */ jsx(FullWidthReportEl, {
    attrs: { "resizing-layout-mode": true }
  }, /* @__PURE__ */ jsx("div", {
    attrs: { slot: `report-header` }
  }, ReportHeaderEl && this.state.renderStage >= 1 ? /* @__PURE__ */ jsx(ReportHeaderEl, {
    attrs: { elref: `reportHeader` },
    params: this.reportHeaderParams(),
    props: this.reportHeaderProps(),
    on: this.reportHeaderEventHandlers,
    hook: { insert: this.helpers.headerInserted }
  }) : /* @__PURE__ */ jsx("div", {
    sel: ".report-header-loading"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-skeleton-header"
  }))), /* @__PURE__ */ jsx("div", {
    attrs: { slot: `query` }
  }, ReportQueryBuilderEl && this.state.renderStage >= 3 ? /* @__PURE__ */ jsx(ReportQueryBuilderEl, {
    params: this.queryBuilderParams(),
    on: this.queryBuilderEventHandlers,
    hook: { insert: this.helpers.qbInserted }
  }) : /* @__PURE__ */ jsx("div", {
    sel: ".qb-loading"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-skeleton-header"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".mp-skeleton-large"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".mp-skeleton-large"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".mp-skeleton-large"
  }))), ReportVisualizationEl && this.state.renderStage >= 2 && /* @__PURE__ */ jsx("div", {
    sel: ".results",
    attrs: { slot: `report` }
  }, visualizationEl)), upsell && /* @__PURE__ */ jsx(UpsellModalEl, {
    attrs: { ...upsell.attrs, elref: `upsellModal` },
    props: upsell.props
  }));
}
